"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusSystemUpdateT = exports.StatusSystemUpdate = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const status_message_js_1 = require("../../solarxr-protocol/rpc/status-message.js");
/**
 * When a new status appears, it's sent alone
 */
class StatusSystemUpdate {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsStatusSystemUpdate(bb, obj) {
        return (obj || new StatusSystemUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsStatusSystemUpdate(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new StatusSystemUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    newStatus(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new status_message_js_1.StatusMessage()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    static startStatusSystemUpdate(builder) {
        builder.startObject(1);
    }
    static addNewStatus(builder, newStatusOffset) {
        builder.addFieldOffset(0, newStatusOffset, 0);
    }
    static endStatusSystemUpdate(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createStatusSystemUpdate(builder, newStatusOffset) {
        StatusSystemUpdate.startStatusSystemUpdate(builder);
        StatusSystemUpdate.addNewStatus(builder, newStatusOffset);
        return StatusSystemUpdate.endStatusSystemUpdate(builder);
    }
    unpack() {
        return new StatusSystemUpdateT((this.newStatus() !== null ? this.newStatus().unpack() : null));
    }
    unpackTo(_o) {
        _o.newStatus = (this.newStatus() !== null ? this.newStatus().unpack() : null);
    }
}
exports.StatusSystemUpdate = StatusSystemUpdate;
class StatusSystemUpdateT {
    constructor(newStatus = null) {
        this.newStatus = newStatus;
    }
    pack(builder) {
        const newStatus = (this.newStatus !== null ? this.newStatus.pack(builder) : 0);
        return StatusSystemUpdate.createStatusSystemUpdate(builder, newStatus);
    }
}
exports.StatusSystemUpdateT = StatusSystemUpdateT;
